<template>
  <q-page class="flex">
    <div class="fit row wrap wrapper">
      <div class="col-12">
       Landing Page
      </div>
    </div>
  </q-page>
</template>

<script>
export default {}
</script>